import React from "react";
import ReturnButton from "./ReturnButton";

export default function Tutorial() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center">
      <ReturnButton />
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-2xl w-full text-center">
        
        <h1 className="text-3xl font-bold mb-4 text-blue-600">
          Tutoriel d’utilisation
        </h1>

        <p className="mb-6 text-gray-700">
          Découvrez comment utiliser <span className="font-semibold">V-repop</span> en quelques étapes simples.
        </p>

        {/* PC / Mac Tutorial */}
        <ol className="text-left mb-8 list-decimal list-inside space-y-3 text-gray-700">
          
          <li>
            Installez l’extension Chrome en cliquant sur{" "}
            <a
              href="https://chromewebstore.google.com/detail/vrepop/depkoiepmnjkkbpcimmfhfndjjbbpkbl"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline font-medium"
            >
              ICI
            </a>{" "}
            (recherchez <b>Vrepop</b> dans le Chrome Web Store).
          </li>

          <li>
            Connectez-vous à votre compte Vinted, allez sur votre page qui affiche
            <b> toutes vos annonces</b> : l’extension <i>V-repop</i> apparaît automatiquement en bas à gauche.
          </li>

          <li>
            Connectez-vous à votre compte <b>V-repop</b> ou créez-en un, puis
            vérifiez que votre abonnement est actif.
          </li>

          <li>
            Choisissez les <b>modifications</b> à appliquer lors de la republication
            (titre, prix, catégories, photos, rotation, cadres…).
          </li>

          <li>
            Après validation des modifications, le bouton <b>“Republier”</b> apparaît
            directement sur la grille de vos annonces : vous pouvez commencer.
          </li>

        </ol>

        {/* YouTube PC video */}
        <div className="aspect-w-16 aspect-h-9 mb-12">
          <iframe
            className="w-full h-96 rounded-lg shadow-md"
            src="https://www.youtube.com/embed/fFju-4OWyI4"
            title="Tutoriel V-repop"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>

        {/* Android Section */}
        <h2 className="text-2xl font-bold mb-4 text-blue-600">
          Utiliser V-repop sur Android (Kiwi Browser)
        </h2>

        <ol className="text-left mb-8 list-decimal list-inside space-y-3 text-gray-700">
          
          <li>
            Installez le navigateur{" "}
            <b>Kiwi Browser</b> :
            <a
              href="https://kiwi-browser-fast-quiet.fr.softonic.com/android"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline ml-1"
            >
              Télécharger Kiwi
            </a>
          </li>

          <li>
            Dans Kiwi, tapez dans la barre d'adresse :{" "}
            <span className="font-mono bg-gray-100 px-2 py-1 rounded">
              chrome://extensions
            </span>
          </li>

          <li>
            Activez <b>“Mode développeur”</b> en haut à droite.
          </li>

          <li>
            Appuyez sur <b>“Ouvrir le Chrome Web Store”</b>.
          </li>

          <li>
            Recherchez <b>Vrepop</b> (⚠️ pas “V-repop” → important !), puis installez l’extension.
          </li>

          <li>
            Ouvrez Vinted dans Kiwi Browser, connectez-vous, allez sur votre page d’annonces :
            le widget <b>V-repop</b> apparaît automatiquement en bas à gauche.
          </li>

          <li>
            Connectez-vous à votre compte V-repop et vérifiez votre abonnement.
          </li>

          <li>
            Configurez vos modifications, puis utilisez le bouton <b>Republier</b> comme sur PC.
          </li>

        </ol>

        {/* Android vidéo */}
        <div className="aspect-w-16 aspect-h-9 mb-6">
          <iframe
            className="w-full h-96 rounded-lg shadow-md"
            src="https://www.youtube.com/embed/WY71FNUbHTY"
            title="Tutoriel V-repop Android"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>

        <p className="text-gray-600 text-sm">
          📌 Si vous avez encore des questions, consultez la{" "}
          <a href="/faq.html" className="text-blue-600 underline">FAQ</a>.
        </p>
      </div>
    </div>
  );
}
